import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.scss'],
})
export class AuditLogsComponent  implements OnInit {

  buttonColorName: any;

  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean
    showExportBtn: boolean,
    showGraphBtn: boolean
    showSearchBar: boolean,
    showAddBtn: boolean,
    currentPage: number,
    showDeleteBtn: boolean,
    tabsData: Array<any>,
    tabsMainData: Array<any>,
    showAccessConfigBtn: boolean,
    showTitle: boolean,
    showBreadCrumbs: boolean,
    showAuditLog: boolean,
    showPermantDeleteBtn: boolean,
    showRestoreBtn: boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs: Array<any>,
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: false, showExportBtn: false,
      showGraphBtn: false, showSearchBar: false, showAddBtn: false, currentPage: 0, showDeleteBtn: false,
      tabsData: [], tabsMainData: [], showAccessConfigBtn: false, showTitle: false, showBreadCrumbs: true,
      showAuditLog: true, showPermantDeleteBtn: false, showRestoreBtn: false, showImportBtn: false, showBackBtn: false,
      showRefreshFunctinallity: false, countTabs: []
    };
  isChangeDetected: boolean = false;
  currentPage: number = 1;
  auditLogId: any;
  auditLogModuleName:any;
  paginationUrl: any = '';
  showListingPage: boolean = true;
  auditLogNumber:any;
  subModuleButtonColor:any;
  loggedInUserCompanyID:any;
  page:any=0;
  constructor(private httpService: HttpService,private config: Config,private datePipe: DatePipe,public router: Router, 
    private activatedroute: ActivatedRoute,private encryptionService: EncryptionService,) { }

  ngOnInit() {
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.activatedroute.params.subscribe((params: any) => {
      this.auditLogId = params?.id;
      this.auditLogModuleName = params?.moduleName;
      this.auditLogNumber = params?.code;
      // this.paginationUrl = this.config.getAllAuditLog + 'Observation' + '/' + this.observationID;
      this.initilaizeColumn();
      this.getAuditLogsData();
    });
  }

  initilaizeColumn() {
    this.gridData.columnInfo = [];
    this.gridData.columnInfo.push({label: 'Field', propertyName: 'fieldName',sortingName: 'columnName'});
    this.gridData.columnInfo.push({label: 'Old Value', propertyName: 'oldValue',sortingName: 'oldValue'});
    this.gridData.columnInfo.push({label: 'New Value', propertyName: 'newValue',sortingName: 'newValue'});
    this.gridData.columnInfo.push({label: 'Changed By', propertyName: 'lastModifiedBy',sortingName: 'lastModifiedBy'});
    this.gridData.columnInfo.push({label: 'Changed On', propertyName: 'updatedAt',sortingName: 'updatedAt'});
  }
  getAuditLogsData(){
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": this.auditLogId
    }
    this.httpService.callPostService(this.config.getEmployeeAuditLog + '?page=' + this.page+'&sort=' + this.sortName + ','+this.sortBy ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  renderColumnData(logData:any){
    this.gridData.columnData = [];
    for (let i = 0; i < logData?.length; i++) {
      this.gridData.columnData.push({
          id: logData[i].id,
          fieldName: logData[i]?.columnName,
          oldValue: logData[i]?.oldValue,
          newValue: logData[i]?.newValue,
          lastModifiedBy: logData[i]?.firstName+' '+logData[i]?.lastName,
          updatedAt: this.datePipe.transform(logData[i]?.updatedAt,"dd MMM yyyy | hh:mm a"),
        });
    }
    this.isChangeDetected = !this.isChangeDetected
    this.mapRenderData();
  }
  renderData:any = [];
  mapRenderData() {
    this.renderData = [];
    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
    }
  }
  sortName:any='updatedAt';
  sortBy:any='desc'
  sortAsending(name:any){
    this.sortName=name;
    this.sortBy = 'asc';
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": this.auditLogId
    }
    this.httpService.callPostService(this.config.getEmployeeAuditLog + '?page=' + this.page+'&sort=' + name + ',asc' ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  sortDesending(name:any){
    this.sortName = name;
    this.sortBy = 'desc';
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": this.auditLogId
    }
    this.httpService.callPostService(this.config.getEmployeeAuditLog + '?page=' + this.page+ this.page+'&sort=' + name + ',desc' ,request).subscribe((res:any)=>{
      this.gridData.totalNoOfPages = res?.data?.totalPages;
      this.gridData.totalCount = res?.data?.total;
      this.gridData.currentPage = res?.data?.currentPageNumber;
      this.renderColumnData(res.data?.logs);
    },(error:any)=>{
      console.log(error)
    })
  }
  pageChange(response:any){
    this.currentPage = response.currentPageNumber - 1;
    this.renderColumnData(response.data.plant);
  }
  backbtn(){
    this.router.navigate(['/home/hrportal/employeemaster', { id: this.auditLogId, operation: 'Show' }]);
  }
  backbtnToListingpage(){
    this.router.navigate(['/home/hrportal/employeemaster']);
  }
  previousPage(){
    if(this.currentPage < 2){
      return;
    }else{
      this.currentPage--;
      this.page--;
      this.getAuditLogsData();
    }
  }
  nextPage(){
    if(this.currentPage >= this.gridData.totalNoOfPages){
      return;
    }
    if(this.currentPage==1){
      this.page=1;
    }else{
      this.page++;
    }
    this.currentPage++;
    this.getAuditLogsData();
  }
}
